const periods = [
  {
    dateFrom: '',
    dateTo: '',
    id: 0,
    name: 'Período Completo'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 1,
    name: 'Hoy'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 2,
    name: 'Ayer'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 3,
    name: 'Últimos 7 días'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 4,
    name: 'Últimos 14 días'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 5,
    name: 'Últimos 30 días'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 6,
    name: 'Este mes'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 7,
    name: 'El mes pasado'
  },

  {
    dateFrom: '',
    dateTo: '',
    id: 8,
    name: 'Este año'
  }
]

export default periods
